import React from 'react';
import { Button } from '@hotmart-org-ca/user-account-ui';

import { cn } from '@/common/utils/clsx';
import type { StepCardProps } from '@/components/step-card/types';

const StepCard = ({
  icon,
  title,
  children,
  buttonText,
  onButtonClick,
  customChildren,
  hiddenButton,
  disabledButton,
  loadingButton,
}: StepCardProps) => {
  const mainClass = cn('mb-4 font-light text-gray-900', {
    'p-4 rounded-lg bg-blue-lighter/25': !customChildren,
  });

  return (
    <div className="flex max-h-[calc(100vh-400px)] min-h-[calc(80vh-36px)] flex-col overflow-auto">
      <div className="mb-4">
        <img src={icon} alt="" className="mb-4 size-[120px]" />
      </div>
      <h2 className="mb-4 text-4 font-light text-gray-900">{title}</h2>
      <div className={mainClass}>{children}</div>
      {!hiddenButton && (
        <div
          className="fixed bottom-0 left-0 flex w-full items-center justify-between border-t border-gray-200
          bg-white p-4 md:relative md:border-none md:bg-transparent md:p-0"
        >
          <Button
            type="button"
            color="primary"
            onClick={onButtonClick}
            loading={!!loadingButton}
            disabled={!!disabledButton}
            fullWidth
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default StepCard;
